import { useAuth } from '@/context/AuthContext';
import { Navigate } from 'react-router-dom';
import { Sneaker, CircleNotch } from '@phosphor-icons/react';

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white" data-testid="loading-screen">
        <CircleNotch size={48} className="animate-spin text-[#FF3B30]" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== 'admin') return <Navigate to="/" replace />;
  return children;
}
